module.exports = __webpack_public_path__ + "static/media/close_icon.b154410a.svg";